import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({progress, title}) => {
  const barWidth = Math.min(Math.max(progress || 0, 0), 100);
  const barWidthDisplay = barWidth === 0 ? '' : barWidth+'%';

  return (
    <div className='progressBarWrap'>      
      <div className='progressBar' style={{width: `${barWidth}%`}}>
        <span className='barTitle'>{title}</span>
        <span className='barSpan'>{barWidthDisplay}</span>
      </div>
    </div>
  );
};

export default ProgressBar;